export enum OfferResponseStatusCode {
    CALCULATE_OFFER = 'CALCULATE_OFFER',
    GET_OFFER = 'GET_OFFER',
}
